/* eslint-disable array-callback-return */
import React from 'react';
import CardC from '../Cards/CardC';
import CardC1 from '../Cards/CardC1';
import "./SectionStyles/Sections.css";


const SectionC = (props) => {
  const CardTheme = [
    {
      value: 2,

    }
  ];
  const cardData = [
    {
      id: 1111,
      name: 'Shaan e Iftar 01',
      price: '353',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1670234201-BBQ-PLATTER-web.jpg&w=256&q=75',
      des: '7 Inches Small data'
    },
    {
      id: 2222,
      name: 'Shaan e Iftar 02',
      price: '450',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1670234201-BBQ-PLATTER-web.jpg&w=256&q=75',
      des: '10 Inches Medium data'
    },
    {
      id: 3333,
      name: 'Shaan e Iftar 03',
      price: '600',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1670234201-BBQ-PLATTER-web.jpg&w=256&q=75',
      des: '14 Inches Large data'
    },
  ];

  return (
    <>
      {CardTheme.map((theme) => {

        if (theme.value === 1) {
          return (
            <div id={props.id} key={theme.value} className='main-main'>
              <h1>{props.Heading}</h1>
              <div className='main'>
                {cardData.map((data, id) => (
                  <CardC
                    key={id}
                    id={data.id}
                    name={data.name}
                    price={data.price}
                    img={data.img}
                    des={data.des}
                  />
                ))}
              </div>
            </div>
          )
        }
        else if (theme.value === 2) {
          return (
            <div id={props.id} key={theme.value} className='main-main'>
              <h1>{props.Heading}</h1>
              <div className='main'>
                {cardData.map((data, id) => (
                  <CardC1
                    key={id}
                    id={data.id}
                    name={data.name}
                    price={data.price}
                    img={data.img}
                    des={data.des}
                  />
                ))}
              </div>
            </div>
          )
        }
      }
      )
      }
    </>
  );
};
SectionC.defaultProps = {
  Heading: "Section C",
  id:'sectionC'
}

export default SectionC;
